module.exports = __webpack_public_path__ + "portal/assets/img/logo.77c8ae0a.svg";